import { Icons } from '@commenda/kakashi';
import { PanelLauncher } from '@commenda/ui/commenda-ai/PanelLauncher';

import { useChatPanel } from 'context/useChatPanel';

import { ChatPanelHelper } from './helpers/chat-panel-helper';

export const ChatPanelLauncher = () => {
  const { isEnabled, isOpen, open } = useChatPanel();

  if (!isEnabled || isOpen) return null;

  const positionStyle = { right: `${ChatPanelHelper.LAUNCHER_OFFSET_PX}px` };

  return (
    <div className="fixed bottom-3xl z-[70]" style={positionStyle}>
      <PanelLauncher
        label="Chat"
        icon={<Icons.Pneuma className="size-4 shrink-0" aria-hidden="true" />}
        onClick={open}
      />
    </div>
  );
};
